import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import {getMenu, getSettings} from '../../../utils/services';
import {currentLang, getPaymentLogos} from '../../../utils/functions';
import LogoNL from '../../../assets/img/logo/logo_nl_white.svg';
import LogoDE from '../../../assets/img/logo/logo_de_white.svg';
import Logo from '../../../assets/img/logo/logo_white.svg';
import { useTranslation } from 'react-i18next';
import W from '../../../components/ui/Word';

const Footer = ({settings_data, footer_menu_data}) => {
    
    let footerLogo = Logo;
    if(currentLang() == 'nl'){
        //footerLogo = LogoNL;
    }
    if(currentLang() == 'de'){
        footerLogo = LogoDE;
    }
    //const [data, setData] = useState(null)
    const [menu, setMenu] = useState(null)
    const [settings, setSettings] = useState(null)
    const { t, i18n } = useTranslation();
    const href = window.location.href;
    const paymentLogos = getPaymentLogos();

    useEffect(() => {
        if(settings_data == undefined){
            getSettings(currentLang());
        }else{
            setSettings(settings_data);
        }
        
    }, [settings_data])

    useEffect(() => {
        if(footer_menu_data == undefined){
            getMenu('footer', 'footer_menu_data');
        }else{
            setMenu(footer_menu_data);
        }
    }, [footer_menu_data])


    return (
        <footer className="footer">
            {/*
            <section className="bg--caramel">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer__language">
                                <a href="/nl">Netherlands </a>
                                <a href="/de">Germany </a>
                                <a href="/uk">United Kingdom </a>
                                <a href="/fr">France </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            */}
            <section className="footer__middle">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-sm-6">
                            <div className="footer__logo">
                                <img src={footerLogo} alt="Grutto" />
                            </div>
                            <div className="footer__address">
                                <W>company.address</W>
                            </div>
                            <div className="footer__social">
                                {t('contact.facebook_url') != "" && 
                                    <a target="_blank" href={t("contact.facebook_url")}><i className="icon-facebook"></i> </a>
                                }
                                {t('contact.twitter_url') != "" && 
                                    <a target="_blank" href={t("contact.twitter_url")}><i className="icon-twitter"></i> </a>
                                }
                                {t('contact.instagram_url') != "" && 
                                    <a target="_blank" href={t("contact.instagram_url")}><i className="icon-instagram"></i></a>
                                }
                            </div>
                        </div>
                        <div className="col-md-7 offset-md-1 col-sm-6 footer__link">
                            {menu && 
                            <ul className="row footer__menu">
                                {menu.map((cat, index)=>{
                                    if(!cat.parent_id){
                                        return(
                                        <li className="col-md-4 col-sm-12">
                                            {!cat.parent_id &&
                                                <h3 className="heading">{cat.title}</h3>
                                            }
                                            <ul>
                                            {menu.map((item, i)=>{                                    
                                                if(item.parent_id == cat.menu_item_id)
                                                    return (<li key={'footerlink-'+i}><a href={item.url}>{item.title}</a></li>)
                                            })}
                                            </ul>
                                        </li>
                                        )
                                    }
                                })}
                            </ul>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <section className="footer__copy">
                <div className="container">
                    <div className="row-item">
                        <div className="copyright">
                            {settings && 
                            <Fragment>
                                {settings[currentLang()+'.footer.google-review'] && parse(settings[currentLang()+'.footer.google-review'])}
                                {settings[currentLang()+'.footer.address']}
                            </Fragment>
                            }
                            
                        </div>
                        <div className="payment-methods">
                            {paymentLogos && paymentLogos.map(item=>{
                                return <i className={"icon-"+item}></i>
                            })}
                            
                        </div>
                    </div>
                </div>
                {/*(href.includes('alpha') || href.includes('local')) &&
                    <button onClick={()=>{window.localStorage.clear()}}>Clear LocalStorage</button>
                        */}
            </section>
        </footer>
    )
}

export default flatstore.connect(['settings_data', 'footer_menu_data'])(Footer);

